import { InformationIcon } from "@/components/detail/InfoIcon";
import { cn } from "@roman/shared/utils";

interface InstructionIconProps {
  width: string;
  height: string;
  onClick: () => void;
  className?: string;
}

export const InstructionIconButton = ({ width, height, onClick, className }: InstructionIconProps) => {
  return (
    <button className={cn("hover:cursor-pointer", className)} onClick={onClick} type="button">
      <InformationIcon width={width} height={height} />
    </button>
  );
};
